import { render, staticRenderFns } from "./LogoutAdmin.vue?vue&type=template&id=448ee365&"
import script from "./LogoutAdmin.vue?vue&type=script&lang=js&"
export * from "./LogoutAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports